import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDrawingAlertEvaluator, } from "@vninvestcharts/engine-react";
let seq = 0;
export function useDrawingAlerts({ enabled, drawings, plotData, updateDrawing, muted = false, }) {
    const [items, setItems] = useState([]);
    const onAlert = useRef(undefined);
    const handleAlert = useCallback((drawing, condition, currentPrice) => {
        seq += 1;
        const item = {
            id: `alert-${drawing.id}-${seq}`,
            drawingType: drawing.type,
            direction: condition.direction === "crossBelow" ? "crossBelow" : "crossAbove",
            price: currentPrice,
            timestamp: Date.now(),
        };
        // Giữ tối đa 3 toast: nhiều hơn thì chắn màn hình.
        setItems((prev) => [item, ...prev].slice(0, 3));
    }, []);
    // Chỉ truyền callback khi thật sự bật — evaluator sớm return nếu undefined.
    onAlert.current = enabled && !muted ? handleAlert : undefined;
    useDrawingAlertEvaluator({
        drawings: drawings,
        plotData,
        updateDrawing,
        onDrawingAlert: onAlert.current,
    });
    const dismiss = useCallback((id) => {
        setItems((prev) => prev.filter((i) => i.id !== id));
    }, []);
    const clear = useCallback(() => setItems([]), []);
    // Tắt cảnh báo thì dọn toast đang treo, không để lại thông báo cũ.
    useEffect(() => {
        if (!enabled || muted)
            setItems([]);
    }, [enabled, muted]);
    return useMemo(() => ({ items, dismiss, clear, isLocalOnly: enabled }), [items, dismiss, clear, enabled]);
}
